var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsotipo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 326 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#06326b;}.cls-3{fill:#d98918;}.cls-4{fill:#c12a21;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 326,
    height: 326
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.78,143.39l.1-85a110.08,110.08,0,0,0-49,32.71V214s-2.61,20.13,19.35,39.87c12.54,11.28,41.5,18.13,53.4,18.87h0c3.35.24,6.87.37,10.56.37V228.74s-26.7,1.32-32.35-17.59a48.55,48.55,0,0,1-2.12-15.27V182.3h34.47V143.39h-34.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.68,174.14H224a66,66,0,0,1-42.5,50.71v46A110.11,110.11,0,0,0,268.68,174.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M159.18,97.26A65.83,65.83,0,0,1,224,151.86h44.72A109.93,109.93,0,0,0,147.09,53.62V98.39A66.07,66.07,0,0,1,159.18,97.26Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipo);
export default __webpack_public_path__ + "static/media/isotipo.b967d12b875276d1d705433766951fc9.svg";
export { ForwardRef as ReactComponent };